export default "724bcd37b8d3dfae197607fdcc55387d.svg";